/* eslint-disable no-unused-vars */

export enum DefaultEnum { DEFAULT = "DEFAULT" }

export enum AppEnum {
    ADMIN = "ADMIN",
    PLATFORM = "PLATFORM",
}

export enum NetworkModeEnum {
    CONNECTED = "CONNECTED",
    OFFLINE = "OFFLINE",
    ONLINE = "ONLINE"
}

export enum ThemeEnum {
    DARK = "dark",
    LIGHT = "light",
    SYSTEM = "system",
}

export enum RoleEnum {
    ADMIN = "admin",
    MODERATOR = "moderator",
    SUPER_ADMIN = "superAdmin",
    VIEWER = "viewer",
}

export enum SheetDirectionEnum {
    BOTTOM = "bottom",
    LEFT = "left",
    RIGHT = "right",
    TOP = "top",
}

export enum ButtonStateEnum {
    DANGER = "danger",
    DEFAULT = "default",
}

export enum BadgeStateEnum {
    COMPLETED_PARTIALLY = "completedPartially",
    DANGER = "danger",
    DEFAULT = "default",
    INPROGRESS = "inprogress",
    LIGHT = "light",
    NOT_PROCESSED = "notProcessed",
    SUCCESS = "success",
    WARNING = "warning",
}

export enum ToastStateEnum {
    DANGER = "danger",
    DEFAULT = "default",
    SUCCESS = "success",
}

export enum ToastActionEnum {
    ADD_TOAST = "ADD_TOAST",
    DISMISS_TOAST = "DISMISS_TOAST",
    REMOVE_TOAST = "REMOVE_TOAST",
    UPDATE_TOAST = "UPDATE_TOAST",
}

export enum InputStateEnum {
    DANGER = "danger",
    DEFAULT = "default",
    SUCCESS = "success",
    WARNING = "warning",
}

export enum InputTypeEnum {
    EMAIL = "email",
    FILE = "file",
    NUMBER = "number",
    PASSWORD = "password",
    SEARCH = "search",
    TEL = "tel",
    TEXT = "text",
    URL = "url",
}

export enum InputModeEnum {
    DECIMAL = "decimal",
    EMAIL = "email",
    NONE = "none",
    NUMERIC = "numeric",
    SEARCH = "search",
    TEL = "tel",
    TEXT = "text",
    URL = "url",
}

export enum FieldTypeEnum {
    DATE = "DATE",
    DATE_RANGE = "DATE_RANGE",
    DATE_TIME = "DATE_TIME",
    FILE = "FILE",
    MULTI_SELECT = "MULTI_SELECT",
    RANGE_SLIDER = "RANGE_SLIDER",
    SELECT = "SELECT",
    SWITCH = "SWITCH",
    TABS = "TABS",
    TEXTAREA = "TEXTAREA"
}

export enum AsyncDataKeyEnum {
    ACCOUNTS = "accounts",
    ACTIONS = "actions",
    CATEGORIES = "categories",
    COUNTRIES = "countries",
    CREDITS = "credits",
    CURRENCIES = "currencies",
    DATA_SOURCES = "dataSources",
    DEBITS = "debits",
    MAPPED_TAGS = "mappedTags",
    ORGANIZATIONS = "organizations",
    REGIONS = "regions",
    RULES = "rules",
    STRUCTURES = "structures",
    TIME_ZONES = "timeZones",
    TYPES = "types"
}

export enum ActionEnum {
    CREATE = "CREATE",
    DELETE = "DELETE",
    DISABLE = "DISABLE",
    EDIT = "EDIT",
    ENABLE = "ENABLE",
    RECONCILE= "RECONCILE",
    SETUP= "SETUP",
    TRANSFORM = "TRANSFORM",
    VIEW = "VIEW",
}

export enum ModuleEnum {
    ACCOUNT = "ACCOUNT",
    ADMIN_DATA_SOURCE = "ADMIN_DATA_SOURCE",
    DATA_SOURCE = "DATA_SOURCE",
    DATA_SOURCE_AUDIT_LOG = "DATA_SOURCE_AUDIT_LOG",
    LEDGER = "LEDGER",
    ORGANIZATION = "ORGANIZATION",
    ORGANIZATIONS_ENTRIES = "ORGANIZATIONS_ENTRIES",
    ORGANIZATION_ENTRIES = "ORGANIZATION_ENTRIES",
    PROFILE = "PROFILE",
    RECONCILIATION = "RECONCILIATION",
    RECONCILIATION_AUDIT_LOG_MATCHING_TRANSACTION = "RECONCILIATION_AUDIT_LOG_MATCHING_TRANSACTION",
    TRANSACTION = "TRANSACTION",
    TRANSACTION_AUDIT_LOG = "TRANSACTION_AUDIT_LOG",
    TRANSACTION_METADATA = "TRANSACTION_METADATA",
    TRANSACTION_VERSION_LOG = "TRANSACTION_VERSION_LOG",
    USER = "USER",
}

export enum TimePartsEnum {
    DAYS = "DAYS",
    HOURS = "HOURS",
    MINUTES = "MINUTES",
}

export enum EmailVerificationEnum {
    UNVERIFIED = "UNVERIFIED",
    VERIFIED = "VERIFIED",
}

export enum CategoryEnum {
    ASSET = "ASSET",
    EQUITY = "EQUITY",
    EXPENSE = "EXPENSE",
    LIABILITY = "LIABILITY",
    REVENUE = "REVENUE",
}

export enum CurrencyEnum {
    AED = "AED",
    ANG = "ANG",
    AUD = "AUD",
    AWG = "AWG",
    BBD = "BBD",
    BDT = "BDT",
    BHD = "BHD",
    BIF = "BIF",
    BRL = "BRL",
    BSD = "BSD",
    BWP = "BWP",
    BZD = "BZD",
    CAD = "CAD",
    CHF = "CHF",
    CLP = "CLP",
    CNY = "CNY",
    COP = "COP",
    CRC = "CRC",
    CVE = "CVE",
    CZK = "CZK",
    DJF = "DJF",
    DKK = "DKK",
    DZD = "DZD",
    EGP = "EGP",
    EUR = "EUR",
    FKP = "FKP",
    GBP = "GBP",
    GEL = "GEL",
    GIP = "GIP",
    GMD = "GMD",
    GNF = "GNF",
    GTQ = "GTQ",
    HKD = "HKD",
    HNL = "HNL",
    HUF = "HUF",
    IDR = "IDR",
    ILS = "ILS",
    INR = "INR",
    IQD = "IQD",
    JOD = "JOD",
    JPY = "JPY",
    KES = "KES",
    KHR = "KHR",
    KMF = "KMF",
    KRW = "KRW",
    KWD = "KWD",
    KYD = "KYD",
    KZT = "KZT",
    LAK = "LAK",
    LBP = "LBP",
    LKR = "LKR",
    LSL = "LSL",
    LYD = "LYD",
    MAD = "MAD",
    MMK = "MMK",
    MNT = "MNT",
    MOP = "MOP",
    MUR = "MUR",
    MVR = "MVR",
    MWK = "MWK",
    MXN = "MXN",
    MYR = "MYR",
    NAD = "NAD",
    NGN = "NGN",
    NIO = "NIO",
    NOK = "NOK",
    NZD = "NZD",
    OMR = "OMR",
    PAB = "PAB",
    PHP = "PHP",
    PKR = "PKR",
    PLN = "PLN",
    QAR = "QAR",
    RON = "RON",
    RUB = "RUB",
    RWF = "RWF",
    SAR = "SAR",
    SCR = "SCR",
    SEK = "SEK",
    SGD = "SGD",
    SHP = "SHP",
    STD = "STD",
    SVC = "SVC",
    SYP = "SYP",
    SZL = "SZL",
    THB = "THB",
    TND = "TND",
    TRY = "TRY",
    TWD = "TWD",
    UAH = "UAH",
    USD = "USD",
    UZS = "UZS",
    VEF = "VEF",
    VND = "VND",
    XAF = "XAF",
    XOF = "XOF",
    XPF = "XPF",
    YER = "YER",
    ZAR = "ZAR",
    ZMW = "ZMW",
}

export enum BalanceEnum {
    CREDIT = "CREDIT",
    DEBIT = "DEBIT",
}

export enum AccountEnum {
    CREDIT = "CREDIT",
    DEBIT = "DEBIT",
}

export enum StatusEnum {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum AccountHierarchyEnum {
    PARENT = "PARENT",
    SUB = "SUB",
}

export enum TransactionFiltersKeyEnum {
    ACCOUNT = "ACCOUNT",
    DATA_SOURCE = "DATA_SOURCE",
    ENTRY = "ENTRY",
    LEDGER = "LEDGER",
    RECONCILIATION = "RECONCILIATION",
}

export enum TransactionStatusEnum {
    ERROR = "ERROR",
    IGNORED = "IGNORED",
    PENDING = "PENDING",
    POSTED = "POSTED",
}

export enum TransactionAmountEnum {
    FEE = "FEE",
    GROSS = "GROSS",
    NET = "NET",
}

export enum TransactionDetailsTabEnum {
    ENTRIES = "ENTRIES",
    LOGS = "LOGS",
    MATCHING = "MATCHING",
    METADATA = "METADATA",
    RELATED = "RELATED",
}

export enum ReconciliationAuditLogDetailsTabEnum {
    OVERVIEW = "OVERVIEW",
    TRANSACTION_MATCHING = "TRANSACTION_MATCHING",
}

export enum TransactionLogsTabEnum {
    AUDIT = "AUDIT",
    VERSION = "VERSION",
}

export enum TransactionAuditActionEnum {
    AUTO_TRANSACTION_CREATED = "AUTO_TRANSACTION_CREATED",
    AUTO_TRANSACTION_MATCH = "AUTO_TRANSACTION_MATCH",
    AUTO_TRANSACTION_UNMATCH = "AUTO_TRANSACTION_UNMATCH",
    MANUAL_METADATA_UPDATED = "MANUAL_METADATA_UPDATED",
    MANUAL_TRANSACTION_CREATED = "MANUAL_TRANSACTION_CREATED",
    MANUAL_TRANSACTION_MATCH = "MANUAL_TRANSACTION_MATCH",
    MANUAL_TRANSACTION_PARTIAL_MATCH = "MANUAL_TRANSACTION_PARTIAL_MATCH",
    METADATA_EDIT = "METADATA_EDIT",
}

export enum TransactionDetailsMatchingModeEnum {
    MATCHED = "MATCHED",
    MATCHING = "MATCHING",
    RECONCILE = "RECONCILE",
    UNMATCHED = "UNMATCHED",
}

export enum ReconciliationStatusEnum {
    EXCEPTIONS = "EXCEPTIONS",
    MATCHED = "MATCHED",
    NOT_PROCESSED = "NOT_PROCESSED",
    PARTIALLY_MATCHED = "PARTIALLY_MATCHED",
    REVIEW = "REVIEW",
    UNMATCHED = "UNMATCHED",
}

export enum ReconciliationJobEnum {
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
    PENDING = "PENDING",
    RUNNING = "RUNNING",
}

export enum ReconciliationAuditLogMatchingTransactionEnum {
    MATCH = "MATCH",
    REVIEW = "REVIEW",
}

export enum ReconciliationFrequencyEnum {
    FREQUENCY_12_HOURS = "FREQUENCY_12_HOURS",
    FREQUENCY_24_HOURS = "FREQUENCY_24_HOURS",
    FREQUENCY_MANUAL = "FREQUENCY_MANUAL",
}

export enum DataSourceEnum {
    ACCOUNTING = "ACCOUNTING",
    BANK = "BANK",
    DATABASE = "DATABASE",
    ERP = "ERP",
    INTERNAL_LEDGER = "INTERNAL_LEDGER",
    NETWORK_FILES = "NETWORK_FILES",
    OTHER = "OTHER",
    PAYMENT_PROVIDER = "PAYMENT_PROVIDER",
    STORAGE_SERVICE = "STORAGE_SERVICE",
}

export enum DataSourceStatusEnum {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    SETTING_UP = "SETTING_UP",
}

export enum DataSourceSyncEnum {
    OFFLINE = "OFFLINE",
    ONLINE = "ONLINE",
}

export enum DataSourceSyncFrequencyEnum {
    FREQUENCY_12_HOURS = "FREQUENCY_12_HOURS",
    FREQUENCY_24_HOURS = "FREQUENCY_24_HOURS",
    FREQUENCY_MANUAL = "FREQUENCY_MANUAL",
}

export enum DataSourceChannelEnum {
    PLAID = "PLAID",
    SYSTEM = "SYSTEM",
}

export enum DataSourceSetupViewEnum {
    API_CONNECTION = "API_CONNECTION",
    DEFAULT = "DEFAULT",
    OFFLINE = "OFFLINE",
    ONLINE = "ONLINE",
}

export enum OfflineMappingDataSourceViewEnum {
    CORE_FIELDS_MAPPING = "CORE_FIELDS_MAPPING",
    PROCESSING_SUMMARY = "PROCESSING_SUMMARY",
    STATUS_MAPPING = "STATUS_MAPPING",
    SUPPORTING_FIELDS_MAPPING = "SUPPORTING_FIELDS_MAPPING",
}

export enum OfflineDataSourceProcessingSummaryTabEnum {
    IGNORED = "IGNORED",
    PENDING = "PENDING",
    POSTED = "POSTED",
}

export enum OfflineDataSourceFieldEnum {
    AMOUNT = "AMOUNT",
    DATE_TIME = "DATE_TIME",
    METADATA = "METADATA",
    NAME = "NAME",
    OTHER_TRANSACTION_IDS = "OTHER_TRANSACTION_IDS",
    STATUS = "STATUS",
    UNIQUE_TRANSACTION_ID = "UNIQUE_TRANSACTION_ID",
}

export enum OfflineDataSourceDateTimeFieldDataActionEnum { COMBINE = "COMBINE" }

export enum OfflineDataSourceDateTimeFieldDateFormatEnum {
    DD_MMM_YYYY="DD-MMM-YYYY (e.g., 31-DEC-2023)",
    DD_MMM_YYYY_SPACE="DD MMM YYYY (e.g., 31 DEC 2023)",
    DD_MM_YYYY ="DD/MM/YYYY (e.g., 31/12/2023)",
    DD_MM_YYYY_DASH ="DD-MM-YYYY (e.g., 31-12-2023)",
    DD_MM_YYYY_DOT ="DD.MM.YYYY (e.g., 31.12.2023)",
    D_M_YYYY ="D/M/YYYY (e.g., 1/5/2023)",
    MMN_DD_YYYY_COMMA="MMM DD, YYYY (e.g., DEC 31, 2023)",
    MM_DD_YY = "MM/DD/YY (e.g., 12/31/23)",
    MM_DD_YYYY = "MM/DD/YYYY (e.g., 12/31/2023)",
    MM_DD_YYYY_DASH = "MM-DD-YYYY (e.g., 12-31-2023)",
    M_D_YY="M/D/YY (e.g., 1/5/23)",
    M_D_YYYY = "M/D/YYYY (e.g., 1/5/2023)",
    YYYYMMDD = "YYYYMMDD (e.g., 20231231)",
    YYYY_MM_DD = "YYYY/MM/DD (e.g., 2023/12/31)",
    YYYY_MM_DD_DASH = "YYYY-MM-DD (e.g., 2023-12-31)"
}

export enum OfflineDataSourceDateTimeFieldTimeFormatEnum {
    HH_MM ="HH:mm (14:30)",
    HH_MM_A = "hh:mm A (02:30 PM)",
    HH_MM_SS ="HH:mm:ss (14:30:45)",
    HH_MM_SS_A ="hh:mm:ss A (02:30:45 PM)",
    ISO_TIME ="THH:mm:ssZ (e.g., T14:30:45Z)",
}

export enum OfflineDataSourceDateTimeFieldTimeZoneEnum {
    UTC = "UTC+00:00",
    UTC_MINUS_1 = "UTC-01:00",
    UTC_MINUS_2 = "UTC-02:00",
    UTC_MINUS_3 = "UTC-03:00",
    UTC_MINUS_4 = "UTC-04:00",
    UTC_MINUS_4_30 = "UTC-04:30",
    UTC_MINUS_5 = "UTC-05:00",
    UTC_MINUS_6 = "UTC-06:00",
    UTC_MINUS_7 = "UTC-07:00",
    UTC_MINUS_8 = "UTC-08:00",
    UTC_MINUS_9 = "UTC-09:00",
    UTC_MINUS_10 = "UTC-10:00", // eslint-disable-line
    UTC_MINUS_11 = "UTC-11:00",
    UTC_PLUS_1 = "UTC+01:00",
    UTC_PLUS_2 = "UTC+02:00",
    UTC_PLUS_3 = "UTC+03:00",
    UTC_PLUS_4 = "UTC+04:00",
    UTC_PLUS_4_30 = "UTC+04:30",
    UTC_PLUS_5 = "UTC+05:00",
    UTC_PLUS_5_30 = "UTC+05:30",
    UTC_PLUS_5_45 = "UTC+05:45",
    UTC_PLUS_6 = "UTC+06:00",
    UTC_PLUS_6_30 = "UTC+06:30",
    UTC_PLUS_7 = "UTC+07:00",
    UTC_PLUS_8 = "UTC+08:00",
    UTC_PLUS_9 = "UTC+09:00",
    UTC_PLUS_9_30 = "UTC+09:30",
    UTC_PLUS_10 = "UTC+10:00", // eslint-disable-line
    UTC_PLUS_11 = "UTC+11:00",
    UTC_PLUS_12 = "UTC+12:00",
    UTC_PLUS_13 = "UTC+13:00",
}

export enum OfflineDataSourceAmountFieldDataActionEnum {
    ARITHMETIC = "ARITHMETIC",
    CONDITIONAL = "CONDITIONAL",
    SEPARATE = "SEPARATE",
}

export enum OfflineDataSourceAmountFieldConditionEnum {
    MINUS = "-",
    PLUS = "+"
}

export enum OfflineDataSourceNameFieldDataActionEnum { COMBINE = "COMBINE" }

export enum OfflineDataSourceNameFieldSeparatorEnum {
    COMMA = ",",
    DASH = "-",
    SLASH = "/",
}

export enum OfflineDataSourceRrnEnum {
    ACH_RETURN_ID = "ach_return_id",
    ARN = "arn",
    CHARGE_ID = "charge_id",
    CUSTOM = "custom",
    INVESTOR_CYCLE_ID = "investor_cycle_id",
    MERCHANT_REFERENCE = "merchant_reference",
    REMITTANCE_ID = "remittance_id",
    RETURN_ID = "return_id",
    SETTLEMENT_ID = "settlement_id",
    TRANSFER_ID = "transfer_id"
}

export enum OrganizationDetailsTabEnum {
    ACTIONS = "ACTIONS",
    OVERVIEW = "OVERVIEW",
    USAGE = "USAGE",
    USERS = "USERS",
}

export enum OrganizationStatusEnum {
    ACTIVE = "ACTIVE",
    SUSPENDED = "SUSPENDED",
}

export enum OrganizationSubscriptionPlanEnum {
    ACTIVE = "ACTIVE",
    CANCELED = "CANCELED",
    TRIAL = "TRIAL",
}

export enum OrganizationOperationRegionEnum {
    APAC_ASIA_PACIFIC = "APAC(ASIA-PACIFIC)",
    EUROPE = "EUROPE",
    LATIN_AMERICA = "LATIN_AMERICA (LATAM)",
    MIDDLE_EAST = "MIDDLE_EAST & NORTH_AFRICA (MENA)",
    NORTH_AMERICA = "NORTH_AMERICA",
    SUB_SAHARAN_AFRICA = "SUB_SAHARAN_AFRICA",
    WORLDWIDE = "WORLDWIDE",
}

export enum OrganizationStructureEnum {
    C_CORPORATION = "C_CORPORATION",
    LLC_LIMITED_LIABILITY_COMPANY = "LLC (LIMITED LIABILITY COMPANY)",
    SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",
    S_CORPORATION = "S_CORPORATION"
}

export enum OrganizationEmployeesNumberLabelEnum {
    ONE_TO_TEN_EMPLOYEES = "1-10 employees (Micro-business / Startup)",
    ELEVEN_TO_FIFTY_EMPLOYEES = "11-50 employees (Small business)", // eslint-disable-line
    FIFTY_ONE_TO_TWO_HUNDRED_EMPLOYEES = "51-200 employees",
    TWO_HUNDRED_TO_FIVE_HUNDRED_EMPLOYEES = "201-500 employees (Medium-sized business)",
    FIVE_HUNDRED_TO_THOUSAND_EMPLOYEES = "501-1000 employees", // eslint-disable-line
    THOUSAND_TO_FIVE_THOUSAND_EMPLOYEES = "1001-5000 employees",
    FIVE_THOUSAND_TO_TEN_THOUSAND_EMPLOYEES = "5001-10000 employees", // eslint-disable-line
    TEN_THOUSAND_PLUS = "10000+ employees (Large enterprise)",
}

export enum ExportOptionsEnum {
    CSV = "CSV",
    JSON = "JSON",
    PDF = "PDF"
}
